import '../../services/tealium/dist/es/types/shared/products.js';
import { mapProductTypeToProductCategory } from '../../services/tealium/dist/es/utils/map-product-type-to-product-category.js';
import { getProductTypeName } from '../../helpers.js';
import { mapProductToTealiumProperties } from './map-product-to-tealium-properties.js';

const mapProductToTealiumViewProperties = (product, activeVariant)=>{
    const productTypeName = getProductTypeName(product);
    return {
        id: 'VirtualPage-View',
        Page_Type: 'Pdp',
        Page_Section1: mapProductTypeToProductCategory(productTypeName),
        Page_Section2: activeVariant.modelCode || '',
        Products: {
            [activeVariant.sku]: mapProductToTealiumProperties(product, activeVariant)
        }
    };
};

export { mapProductToTealiumViewProperties };
//# sourceMappingURL=map-product-to-tealium-view-properties.js.map
